var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15694",
    "data-name": "Group 15694",
    transform: "translate(-827 -698)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2040",
    "data-name": "Rectangle 2040",
    width: 25,
    height: 25,
    transform: "translate(827 698)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(-4589.232 34.398)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 3.073,
    cy: 3.073,
    r: 3.073,
    transform: "translate(5419.233 666.602)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 3.073,
    cy: 3.073,
    r: 3.073,
    transform: "translate(5432.966 673.526)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 3.073,
    cy: 3.073,
    r: 3.073,
    transform: "translate(5419.233 680.433)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_414",
    "data-name": "Rectangle 414",
    width: 10.888,
    height: 1.396,
    transform: "translate(5424.546 670.219) rotate(26.924)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_415",
    "data-name": "Rectangle 415",
    width: 10.668,
    height: 1.396,
    transform: "matrix(0.899, -0.437, 0.437, 0.899, 5424.017, 681.769)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharePurple);
export default __webpack_public_path__ + "static/media/share-purple.0515a0d76c899a28320b1dbd51638c14.svg";
export { ForwardRef as ReactComponent };